export default {
  title: {
    baseInfo: 'Basic Info',
    education: 'Education',
    workExperience: 'Work Experience',
    partTimeExperience: 'Intern / Part Time Experience',
    additionalInfo: 'Additional Info',
    language: 'Language'
  },
  label: {
    myProfile: 'My Profile',
    legalName: 'Legal Name',
    homeLocation: 'Home Location',
    currentLocation: 'Current Location',
    email: 'Email Address',
    mobileId: 'Mobile ID',
    address: 'Address',
    salutation: 'Salutation',
    otherAddress: 'Address (Other - If Have)',
    birthday: 'Date of Birth',
    phone: 'Mobile Phone',
    gender: 'Gender',
    secondPhone: 'Second Phone',
    chatId: 'Chat ID',
    socialNetwork: 'Social Network(s)',
    expectedSalary: 'Expected Salary',
    school: 'School',
    degreeAndMajor: 'Degree And Major',
    date: 'Date',
    now: 'Now',
    companyName: 'Company',
    jobTitle: 'Title',
    industry: 'Industry',
    location: 'Location',
    salary: 'Salary',
    description: 'Description',
    professionalMemberShip: 'Professional Memberships',
    awards: 'Awards',
    hobbies: 'Hobbies',
    language: 'Languages',
    Mr: 'Mr.',
    Mrs: 'Mrs',
    Ms: 'Ms.',
    dates: {
      years: '{num} years',
      months: '{num} months',
      days: '{num} days',
      year: '{num} year',
      month: '{num} month',
      day: '{num} day'
    },
    editResume: 'edit'
  },
  btn: {
    viewProfile: 'View Profile',
    viewResume: 'View Resume',
    finishProfile: 'Please finish your personal information'
  }
}
